const createUiSlice = (set: (data: any) => void, get: () => any) => ({
  selectedEquipment: undefined,
  selectedNotification: undefined,


  selectEquipment: (equipment: any) => {
    set({ selectedEquipment: equipment });
  },

  selectNotification: (notification: any) => {
    set({ selectedNotification: notification });
  },


});
export default createUiSlice;
